import { io } from 'socket.io-client';

// IMPORTANT: NO /api here
const socket = io('https://api.practicalinfosec.com', {
  transports: ['websocket'],
  autoConnect: true,
});

export default socket;

